import * as actionType from "./action";

export function logstashPipelinesReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_LOGSTASH_PIPELINES_SUCCESS:
      return { ...state, response };
    case actionType.GET_LOGSTASH_PIPELINES_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function logstashPipelineStatsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_LOGSTASH_PIPELINE_STATS_SUCCESS:
      return { ...state, response };
    case actionType.GET_LOGSTASH_PIPELINE_STATS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
